import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { LoginPage } from '../pages/login/login';

declare const document:any;
@Component({

   templateUrl: 'app.html'
})

export class MyApp
{

   rootPage:any = LoginPage;

   /** ----- Constructor ----- **/

   constructor( platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen )
   {
      platform.ready().then(() => {
         // Okay, so the platform is ready and our plugins are available.
         // Here you can do any higher level native things you might need.
         statusBar.styleLightContent();
         splashScreen.hide();

      });
   }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts